import { Component, Input } from '@angular/core';
import { DynamicFormComponent } from '../../../dynamic-form/dynamic-form.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DynamicFormService } from '../../../../services/dynamic-form.service';
import { DynamicForm } from '../../../../models/dynamic-form';
import { LoadingService } from '../../../../services/loading.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SvgIconComponent } from '../../../svg-icon/svg-icon.component';
import { Condition, DeliveryMode, ImportType, ScanStatus, ScanType } from '../../../../constants/operations-contsants';
import { ToasterService } from '../../../../services/toaster.service';
import { InventoryService } from '../../../../services/inventory-service';

@Component({
  selector: 'app-manage-containers',
  standalone: true,
  imports: [DynamicFormComponent, SvgIconComponent],
  templateUrl: './manage-containers.component.html',
  styleUrl: './manage-containers.component.scss'
})
export class ManageContainersComponent {

  @Input() formConfig!: DynamicForm;
  @Input() returnPath!: string;

  containerForm!: FormGroup;
  readOnlyMode: boolean = false;
  editingEnabled: boolean = false;
  containerId: string = "";
  container: any = {};

  scanTypeOptions = Object.entries(ScanType).map(([key, value]) => ({ value: key, label: value.label }));
  scanStatusOptions = Object.entries(ScanStatus).map(([key, value]) => ({ value: key, label: value.label }));
  filteredScanStatusOptions: any = [...this.scanStatusOptions];
  conditionOptions = Object.entries(Condition).map(([key, value]) => ({ value: key, label: value.label }));
  importTypeOptions = Object.entries(ImportType).map(([key, value]) => ({ value: key, label: value.label }));
  deliveryModeOptions = Object.entries(DeliveryMode).map(([key, value]) => ({ value: key, label: value.label }));


  constructor(private dynamicFormService: DynamicFormService,
              private loadingService: LoadingService,
              private inventoryService: InventoryService,
              private toasterService: ToasterService,
              private route: ActivatedRoute, private router: Router) {
    this.containerForm = new FormBuilder().group({});
  }

  ngOnInit(): void {
    //this.containerForm = this.dynamicFormService.addControlsToForm(this.containerForm, this.formConfig);
    this.initFormControls();
    this.containerId = this.route.snapshot.paramMap.get("container-id") || "";

    if (this.containerId === "") {
      this.readOnlyMode = false;
      this.editingEnabled = false;
      return;
    }

    if (this.route.snapshot.url[0].path === "edit") {
      this.editingEnabled = true;
      this.readOnlyMode = false;
    } else {
      this.editingEnabled = false;
      this.readOnlyMode = true;
      this.containerForm.disable();
    }

    this.loadingService.show();
    this.inventoryService.getContainerById(this.containerId, false, false).subscribe({
      next: (response: any) => {
        const data = response?.data;
        this.patchContainerData(data);
        this.loadingService.hide();
      },
      error: (error) => {
        console.error(error);
        this.loadingService.hide();
      }
    });
  }

  initFormControls() {
    console.log("Form Config: ", this.formConfig);
    this.containerForm = this.dynamicFormService.addControlsToForm(this.containerForm, this.formConfig);
    const scanTypeField = this.formConfig?.formRows.flatMap(row => row.formGroups).find((formGroup: any) => formGroup?.control?.label === 'scanType');
    const scanStatusField = this.formConfig?.formRows.flatMap(row => row.formGroups).find((formGroup: any) => formGroup?.control?.label === 'scanStatus');
    const importTypeField = this.formConfig?.formRows.flatMap(row => row.formGroups).find((formGroup: any) => formGroup?.control?.label === 'importType');
    const conditionField = this.formConfig?.formRows.flatMap(row => row.formGroups).find((formGroup: any) => formGroup?.control?.label === 'condition');
    const deliveryModeField = this.formConfig?.formRows.flatMap(row => row.formGroups).find((formGroup: any) => formGroup?.control?.label === 'deliveryMode');
    const doDeliveryModeField = this.formConfig?.formRows.flatMap(row => row.formGroups).find((formGroup: any) => formGroup?.control?.label === 'deliveryModeFromDO');

    if (scanTypeField?.control?.fieldInfo?.options) {
      scanTypeField.control.fieldInfo.options = this.scanTypeOptions;
    }
    if (scanStatusField?.control?.fieldInfo?.options) {
      scanStatusField.control.fieldInfo.options = this.scanStatusOptions;
    }
    if (importTypeField?.control?.fieldInfo?.options) {
      importTypeField.control.fieldInfo.options = this.importTypeOptions;
    }
    if (conditionField?.control?.fieldInfo?.options) {
      conditionField.control.fieldInfo.options = this.conditionOptions;
    }
    if (deliveryModeField?.control?.fieldInfo?.options) {
      deliveryModeField.control.fieldInfo.options = this.deliveryModeOptions;
    }
    if (doDeliveryModeField?.control?.fieldInfo?.options) {
      doDeliveryModeField.control.fieldInfo.options = this.deliveryModeOptions;
    }
  }

  patchContainerData(container: any) {
    this.container = container;
    if (container) {
      this.containerForm.patchValue({
        ...container,
        isoCode: container?.isoCode ?  { key: container.isoCode, value: container.isoCode } : null,
        vesselId: container?.vesselId && container?.vesselName ? { key: container.vesselId, value: container.vesselName } : null,
        accountHolderId: container?.accountHolderId && container?.accountHolderName ? { key: container.accountHolderId, value: container.accountHolderName } : null,
        secondaryCustomerId: container?.secondaryCustomerId && container?.secondaryCustomerName ? { key: container.secondaryCustomerId, value: container.secondaryCustomerName } : null,
        shippingLineId: container?.shippingLineId && container?.shippingLineName ? { key: container.shippingLineId, value: container.shippingLineName } : null
      });
    }
  }

  onAutoCompleteSuggestionSelected(event: {controlName: string, result: any}) {
    const { controlName, result } = event;
    if (controlName === 'isoCode') {
      this.containerForm.get('containerSize')?.setValue(result.size);
      this.containerForm.get('containerType')?.setValue(result.type);
    } else if (controlName === 'accountHolderId') {
      if (!this.containerForm.get('secondaryCustomerId')?.value) {
        this.containerForm.get('secondaryCustomerId')?.setValue({ key: result.id, value: result.name });
      }
    }
  }

  cancel() {
    this.goBack();
  }

  goBack() {
    this.router.navigateByUrl(this.returnPath);
  }

  saveForm() {
    this.containerForm.markAllAsTouched();
    if (!this.containerForm.valid) {
      console.log("Form is invalid");
      return
    }

    this.loadingService.show();
    const containerData = {
      ...this.container,
      ...this.containerForm.value,
      isoCode: this.containerForm.get('isoCode')?.value?.key,
      vesselId: this.containerForm.get('vesselId')?.value?.key,
      accountHolderId: this.containerForm.get('accountHolderId')?.value?.key,
      secondaryCustomerId: this.containerForm.get('secondaryCustomerId')?.value?.key,
      shippingLineId: this.containerForm.get('shippingLineId')?.value?.key,
    }

    if (this.editingEnabled) {
      this.updateContainer(containerData);
    }
  }

  private updateContainer(container: any) {
    console.log("Updating container: ", this.containerId);
    this.inventoryService.updateContainer(this.containerId, container).subscribe({
      next: (response: any) => {
        this.loadingService.hide();
        this.toasterService.success(
          `Container has been updated successfully!`
        );
        this.loadingService.hide();
        this.goBack();
      },
      error: (error) => {
        this.toasterService.error(error.error.errorDesc);
        console.error(error);
        this.loadingService.hide();
      }
    });
  }


}
